<template>
  <v-app id="aula">
    <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" mobile-break-point="500" v-model="drawer" v-if="login" fixed app>
      <v-list dense>
        <template v-for="item in itemsMenu">
          <v-layout v-if="item.heading" :key="item.heading" row align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group v-else-if="item.children" v-model="item.model" :key="item.text" :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="(child, i) in item.children" :key="i">
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text" :to="item.url">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-list-tile @click="cerrarSesion()">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Salir
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="blue darken-3" v-if="login" dark app fixed>
      <v-toolbar-title style="width: 300px" class="ml-0">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">{{ empresa }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <div class="v-toolbar__items">
        <v-menu offset-y>
          <v-btn slot="activator" class="v-btn--flat">
            <span><v-icon>home</v-icon></span> <span>{{ local }}</span>
          </v-btn>
          <v-list>
            <v-list-tile v-for="(item, index) in locales" :key="index" @click="setLocal(item.nombre)">
              <v-list-tile-title>{{ item.nombre }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <div class="v-toolbar__items">
        <v-menu offset-y>
          <v-btn slot="activator" class="v-btn--flat">
            <span><v-icon>account_circle</v-icon></span> <span>{{ usuario }}</span>
          </v-btn>
          <v-list>
            <v-list-tile @click.stop="cambiarClave.open = true">
              <v-list-tile-title>Cambiar clave</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="cerrarSesion()">
              <v-list-tile-title>Cerrar sesión</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
    <v-content>
      <v-alert v-if="entorno === 'development'" :value="true" type="warning">Entorno de desarrollo</v-alert>
      <v-container fluid fill-height>
          <v-layout justify-center>
              <main>
                <router-view :usuarioApp="usuario" :tipoUsuario="tipoUsuario" :sedes="sedes" :etapa="etapa" v-bind:login="login" v-on:login="loginOff" v-on:set-token="setToken"></router-view>
              </main>
          </v-layout>
      </v-container>
    </v-content>
    <v-dialog v-model="dialog" v-bind:max-width="dialogW">
      <v-btn fixed top right @click="cerrar" icon>
        <v-icon>close</v-icon>
      </v-btn>
      <center><img :src="popupSrc" /></center>
    </v-dialog>
    <cambiar-clave v-bind:cambiarClave="cambiarClave"></cambiar-clave>
    <!-- <login v-if="!login" v-bind:login="loginForm" v-on:set-token="setToken" v-bind:msgError="this.loginMsg"></login> -->
  </v-app>
</template>

<script>
  import mixin from './mixins.js'
  export default {
    name: 'app',
    mixins: [mixin],
    data: () => ({
      tokenId: '',
      login: false,
      loginForm: {open: false},
      loginMsg: '',
      cambiarClave: {open: false},
      drawer: null,
      entorno: '',
      locales: [],
      sedes: [],
      local: '',
      empresa: '',
      usuario: '',
      tipoUsuario: '',
      dialog: false,
      dialogW: '400px',
      etapa: ''
    }),
    props: {
      source: String
    },
    beforeMount () {
      this.entorno = process.env.NODE_ENV
      this.tokenId = localStorage.getItem('tokenId')
      this.local = localStorage.getItem('local')
      this.variablesApp()
    },
    watch: {
      tokenId (val) {
        localStorage.setItem('tokenId', val)
      },
      local (val) {
        localStorage.setItem('local', val)
        if (val === 'undefined') {
          localStorage.setItem('local', '')
        }
      },
      login (val) {
        if (val === false) {
          this.loginForm.open = true
        }
      }
    },
    computed: {
      popupSrc () {
        return `${process.env.API}/archivos/resultados2.png`
      },
      itemsMenu () {
        var menu = []
        if (this.usuario === 'adminsan') {
          menu = [
            { icon: 'account_balance', text: 'Colegios', url: '/Colegios' },
            { icon: 'print', text: 'Inscritos', url: '/Estudiantes' },
            { icon: 'attach_money', text: 'Verificar pagos', url: '/Pagos' },
            { icon: 'comments', text: 'Resultados', url: '/Resultados' },
            { icon: 'comments', text: 'Reportes', url: '/Reportes' },
            { icon: 'build', text: 'Configuración', url: '/Configuracion' },
            { icon: 'person', text: 'Usuarios', url: '/Usuarios' },
            { icon: 'location_city', text: 'Sedes', url: '/Sedes' }
          ]
        } else if (this.tipoUsuario === 'ADM') {
          menu = [
            { icon: 'account_balance', text: 'Colegios', url: '/Colegios' },
            { icon: 'print', text: 'Inscritos', url: '/Estudiantes' },
            { icon: 'attach_money', text: 'Verificar pagos', url: '/Pagos' },
            { icon: 'comments', text: 'Resultados', url: '/Resultados' },
            { icon: 'comments', text: 'Reportes', url: '/Reportes' }
          ]
        } else if (this.tipoUsuario === 'COL') {
          // this.tipoUsuario === 'DEL'
          if (this.etapa === 'I') {
            menu = [
              { icon: 'account_balance', text: 'Datos del colegio', url: '/Colegio' },
              { icon: 'assignment', text: 'Ficha de inscripción', url: '/FichaInscripcion' },
              { icon: 'attach_money', text: 'Ficha de pago', url: '/Pago' },
              { icon: 'print', text: 'Verificar inscritos', url: '/Inscritos' },
              { icon: 'credit_card', text: 'Credenciales', url: '/Credenciales' }
            ]
          } else {
            menu = [
              { icon: 'comments', text: 'Resultado', url: '/Resultado' }
            ]
          }
        } else {
          if (this.etapa === 'I') {
            menu = [
              { icon: 'assignment', text: 'Ficha de inscripción', url: '/Ficha' },
              { icon: 'attach_money', text: 'Ficha de pago', url: '/Pago' },
              { icon: 'credit_card', text: 'Credencial', url: '/Credenciales' }
            ]
          } else {
            menu = [
              { icon: 'comments', text: 'Resultado', url: '/Resultado' }
            ]
          }
        }
        return menu
      }
    },
    methods: {
      variablesApp () {
        var solicitudApi = this.crearSolicitud()
        const myRequest = new Request(`${process.env.API}inicioApp.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
        this.loading = true
        return fetch(
          myRequest
        )
          .then(response => response.json())
          .then(datos => {
            if (datos.l === false) {
              this.empresa = ''
              this.usuario = ''
              this.tipoUsuario = ''
              this.locales = []
              this.local = ''
              localStorage.setItem('local', '')
              this.$router.push('/Ingresar')
              this.dialog = datos.d.popup
              this.dialogW = datos.d.popupW + 'px'
              this.etapa = datos.d.etapa
            } else {
              this.login = datos.l
              this.empresa = datos.d.empresa
              this.usuario = datos.d.usuario
              this.tipoUsuario = datos.d.tipo
              this.locales = datos.d.locales
              this.etapa = datos.d.etapa
              this.sedes = []
              for (var idLocal in datos.d.locales) {
                this.sedes.push({id: idLocal, nombre: datos.d.locales[idLocal].nombre})
              }
              if (localStorage.getItem('local') !== '') {
                this.setLocal(localStorage.getItem('local'))
              } else {
                this.setLocal(datos.d.local)
              }
            }
          })
      },
      cerrar () {
        this.dialog = false
      },
      setToken (token) {
        this.tokenId = token
        this.login = true
        if (this.empresa === '') {
          localStorage.setItem('tokenId', token)
          if (this.tipoUsuario !== 'ADM') {
            this.$router.push('/Inicio')
          } else {
            this.$router.push('/Inicio')
          }
          this.variablesApp()
        }
      },
      setLocal (local) {
        for (var buscar in this.locales) {
          if (this.locales[buscar].nombre === local) {
            localStorage.setItem('local', local)
            this.local = local
            if (this.tipoUsuario !== 'ADM') {
              if (this.etapa === 'R') {
                this.$router.push('/Resultado')
                this.drawer = false
              } else {
                this.$router.push('/Inicio')
              }
            } else {
              this.$router.push('/Inicio')
            }
            return
          }
        }
        localStorage.setItem('local', this.local)
        this.$router.push('/Inicio')
      },
      loginOff (msg) {
        this.login = false
        if (0 in msg) {
          this.loginMsg = msg[0]
        } else {
          this.loginMsg = msg
        }
        // this.loginForm.open = true
      },
      cerrarSesion () {
        localStorage.setItem('tokenId', '')
        localStorage.setItem('local', '')
        this.empresa = ''
        this.usuario = ''
        this.tipoUsuario = ''
        this.login = false
        this.$router.push('/Ingresar')
      }
    }
  }
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  width: 98%
}

.v-toolbar__content, .v-toolbar__extension {
    padding: 0 4px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue